import { jsx } from 'react/jsx-runtime';
import { ModalBase } from '../modal-base/components.js';

const Modal = _ref => {
  let {
    ...props
  } = _ref;
  return /*#__PURE__*/jsx(ModalBase, {
    ...props
  });
};

export { Modal };
//# sourceMappingURL=components.js.map
